import { BankingEntitiesCardPaymentCalculatedLabelEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const statusText = (
  internalStatus: BankingEntitiesCardPaymentCalculatedLabelEnum
): string => {
  switch (internalStatus) {
    case 'complete':
      return i18n.t('banking.card_payments.status.completed')
    case 'decline':
      return i18n.t('banking.card_payments.status.declined')
    case 'refund':
      return i18n.t('banking.card_payments.status.refunded')
    case 'reverse':
      return i18n.t('banking.card_payments.status.reversed')
    case 'withhold':
      return i18n.t('banking.card_payments.status.withheld')
  }
}
